const StashContent = [
  {
    StashImg: "Person.png",
    StashFirstName: "Olivia Rhye",
    StashEmail: "olivia@untitledui.com",
    NFTEdition: "100/234",
    TotalSales: "1500$",
    Submissions: "100",
    CurrentBounties: "25500",
    SubData: {
      SubmissionName: "Nortoln Smash",
      Preview: "WhiteLayer.png",
      Creators: "GetherPerson.png",
      Open: ["mic.png", "speaker.png", "volume.png", "doll.png"],
      Wavpool: "009",
      Props: "pancha.png",
      Date: "10/12/22 09:40pm",
    },
  },
  {
    StashImg: "Person.png",
    StashFirstName: "Olivia Royal",
    StashEmail: "olivia@untitledui.com",
    NFTEdition: "289/289",
    TotalSales: "1500$",
    Submissions: "100",
    CurrentBounties: "25500",
    SubData: {
      SubmissionName: "Nortoln Smash",
      Preview: "WhiteLayer.png",
      Creators: "GetherPerson.png",
      Open: ["mic.png", "speaker.png", "volume.png", "doll.png"],
      Wavpool: "009",
      Props: "pancha.png",
      Date: "10/12/22 09:40pm",
    },
  },
  {
    StashImg: "Person.png",
    StashFirstName: "Olivia Royal",
    StashEmail: "olivia@untitledui.com",
    NFTEdition: "104/110",
    TotalSales: "1500$",
    Submissions: "100",
    CurrentBounties: "25500",
    SubData: {
      SubmissionName: "Nortoln Smash",
      Preview: "WhiteLayer.png",
      Creators: "GetherPerson.png",
      Open: ["mic.png", "speaker.png", "volume.png", "doll.png"],
      Wavpool: "009",
      Props: "pancha.png",
      Date: "10/12/22 09:40pm",
    },
  },
  {
    StashImg: "Person.png",
    StashFirstName: "Olivia Royal",
    StashEmail: "olivia@untitledui.com",
    NFTEdition: "289/289",
    TotalSales: "1500$",
    Submissions: "100",
    CurrentBounties: "24888",
    SubData: {
      SubmissionName: "Nortoln Smash",
      Preview: "WhiteLayer.png",
      Creators: "GetherPerson.png",
      Open: ["mic.png", "speaker.png", "volume.png", "doll.png"],
      Wavpool: "009",
      Props: "pancha.png",
      Date: "10/12/22 09:40pm",
    },
  },
  {
    StashImg: "Person.png",
    StashFirstName: "Olivia Royal",
    StashEmail: "olivia@untitledui.com",
    NFTEdition: "289/289",
    TotalSales: "1500$",
    Submissions: "100",
    CurrentBounties: "24888",
    SubData: {
      SubmissionName: "Nortoln Smash",
      Preview: "WhiteLayer.png",
      Creators: "GetherPerson.png",
      Open: ["mic.png", "speaker.png", "volume.png", "doll.png"],
      Wavpool: "009",
      Props: "pancha.png",
      Date: "10/12/22 09:40pm",
    },
  },
];

const Submission = [
  {
    SubmissionName: "Nortoln Smash",
    BountiesImg: ["mic.png", "speaker.png", "volume.png", "doll.png"],
    Preview: "layerMusic.png",
    Creators: "GetherPerson.png",
    Wavpool: "009",
    TxnHash: "0x34T..4U",
    Date: "10/12/22 09:40pm",
  },
  {
    SubmissionName: "Nortoln Smash",
    BountiesImg: ["mic.png", "speaker.png", "volume.png", "doll.png"],
    Preview: "layerMusic.png",
    Creators: "GetherPerson.png",
    Wavpool: "009",
    TxnHash: "0x34T..4U",
    Date: "10/12/22 09:40pm",
  },
  {
    SubmissionName: "Nortoln Smash",
    BountiesImg: ["mic.png", "speaker.png", "volume.png", "doll.png"],
    Preview: "layerMusic.png",
    Creators: "GetherPerson.png",
    Wavpool: "009",
    TxnHash: "0x34T..4U",
    Date: "10/12/22 09:40pm",
  },
  {
    SubmissionName: "Nortoln Smash",
    BountiesImg: ["mic.png", "speaker.png", "volume.png", "doll.png"],
    Preview: "layerMusic.png",
    Creators: "GetherPerson.png",
    Wavpool: "009",
    TxnHash: "0x34T..4U",
    Date: "10/12/22 09:40pm",
  },
  {
    SubmissionName: "Nortoln Smash",
    BountiesImg: ["mic.png", "speaker.png", "volume.png", "doll.png"],
    Preview: "layerMusic.png",
    Creators: "GetherPerson.png",
    Wavpool: "009",
    TxnHash: "0x34T..4U",
    Date: "10/12/22 09:40pm",
  },
  {
    SubmissionName: "Nortoln Smash",
    BountiesImg: ["mic.png", "speaker.png", "volume.png", "doll.png"],
    Preview: "layerMusic.png",
    Creators: "GetherPerson.png",
    Wavpool: "009",
    TxnHash: "0x34T..4U",
    Date: "10/12/22 09:40pm",
  },
];

export { StashContent, Submission };
